import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SellerKycGuidePage.module.css';

const SellerKycGuidePage = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>IRIE TIX 本人確認（Stripe）について</h1>
        <p className={styles.lead}>チケット販売を行うには本人確認が必要です</p>

        <p className={styles.text}>
          IRIE TIXでチケット販売を行うには、
          安全な決済と売上振込のため、Stripeによる本人確認（口座登録）が必要です。
        </p>
        <p className={styles.text}>
          Stripeは世界中で利用されているオンライン決済サービスです。
          本人確認はStripeの画面で行われます。
        </p>

        <h2 className={styles.sectionTitle}>手続きの概要</h2>
        <ul className={styles.list}>
          <li className={styles.listItem}><img src="/icons/clock.svg" alt="時計" className={styles.inlineIcon} />所要時間：通常数分</li>
          <li className={styles.listItem}><img src="/icons/camera.svg" alt="カメラ" className={styles.inlineIcon} />本人確認書類（運転免許証など）が必要です</li>
          <li className={styles.listItem}><img src="/icons/ginko.svg" alt="銀行" className={styles.inlineIcon} />振込口座情報を入力します</li>
        </ul>
        <p className={styles.note}>※ 氏名・住所は本人確認書類と同じ表記で入力してください。</p>
        <p className={styles.note}>※ 法人でない方は「個人事業主」を選択してください</p>
        <p className={styles.note}>
          ※ 開業届を提出していない方、副業の方も「個人事業主」で問題ありません
        </p>

        <h2 className={styles.sectionTitle}>Stripe入力項目のガイド</h2>
        <p className={styles.text}>Stripeの画面では、以下の情報を入力します。</p>

        <h3 className={styles.subTitle}>① 事業形態</h3>
        <p className={styles.text}>選択肢：</p>
        <ul className={styles.list}>
          <li className={styles.listItem}>個人事業主</li>
          <li className={styles.listItem}>法人</li>
          <li className={styles.listItem}>非営利組織</li>
        </ul>
        <p className={styles.text}>法人・非営利組織でない場合は「個人事業主」を選択してください。</p>

        <h3 className={styles.subTitle}>② 業種</h3>
        <p className={styles.text}>「イベント関連」「エンターテインメント」「チケット販売」に近いものを選択してください。</p>

        <h3 className={styles.subTitle}>③ ウェブサイト</h3>
        <p className={styles.text}>販売内容が確認できる公開URLを入力してください。</p>
        <p className={styles.text}>入力例：</p>
        <ul className={styles.list}>
          <li className={styles.listItem}>IRIE TIXのプロフィールページ</li>
          <li className={styles.listItem}>https://irietix.com/profile/あなたのスラッグ</li>
          <li className={styles.listItem}>ご自身の公式サイト</li>
        </ul>
        <p className={styles.note}>※ 未公開ページや準備中ページは使用できません。</p>

        <h3 className={styles.subTitle}>④ 商品・サービスの説明（入力例）</h3>
        <p className={styles.exampleLabel}>主催者向け例</p>
        <p className={styles.text}>
          音楽イベントやライブのチケットをIRIE TIXを通じてオンライン販売しています。SNSや公式サイトで告知を行い、
          クレジットカード決済で事前販売を行っています。イベント当日に入場サービスを提供します。
        </p>
        <p className={styles.exampleLabel}>アーティスト向け例</p>
        <p className={styles.text}>
          出演イベントやライブのチケットをIRIE TIXを通じて販売しています。オンライン決済により事前販売を行い、
          イベント当日にサービスを提供します。
        </p>
        <p className={styles.exampleLabel}>会場向け例</p>
        <p className={styles.text}>
          会場で開催されるイベントのチケットをIRIE TIXを通じて販売しています。オンライン決済で事前販売を行っています。
        </p>

        <h2 className={styles.sectionTitle}>よくある質問</h2>
        <h3 className={styles.subTitle}>Q. 開業届を出していません</h3>
        <p className={styles.text}>問題ありません。法人でない場合は「個人事業主」を選択してください。</p>

        <h3 className={styles.subTitle}>Q. なぜ本人確認が必要ですか？</h3>
        <p className={styles.text}>
          チケット販売では金融取引が発生するため、法律上の本人確認が必要です。
          IRIE TIXではStripeを通じて安全な決済環境を提供しています。
        </p>

        <h2 className={styles.sectionTitle}>販売を開始する</h2>
        <p className={styles.text}>ダッシュボードの「販売を開始する」ボタンから、Stripeの本人確認へお進みください。</p>

        <div className={styles.backRow}>
          <Link className={styles.backLink} to="/dashboard">← ダッシュボードに戻る</Link>
        </div>
      </div>
    </div>
  );
};

export default SellerKycGuidePage;
